import { brandedUuid } from '@multiplier/lib-shared-flavor';
export const UserIdSchema = brandedUuid('Invalid user ID format');
//# sourceMappingURL=UserSchemas.js.map